import type { StateDependencyItem } from '@atlassian/jira-aais-dependency-lines-overlay/src/common/ui/types.tsx';
import { type IssueId, toIssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import { DEFAULT_ITEM_HEIGHT } from '@atlassian/timeline-table/common/constants';
import type { Hash, ChartDataHash } from '../types.tsx';
import {
	evaluateTargetDependencyDate,
	evaluateSourceDependencyDate,
} from './get-dependency-dates/index.tsx';
import { isDependencyDatesOverlapping } from './is-dependency-dates-overlapping/index.tsx';

export const getDependenciesItems = (
	positionsHash: Hash<number>,
	itemsHash: ChartDataHash,
	dependenciesHash: Hash<IssueId[]>,
	startDateHash: Hash<number | undefined>,
	dueDateHash: Hash<number | undefined>,
): StateDependencyItem[] => {
	const dependencies: StateDependencyItem[] = [];

	Object.keys(dependenciesHash).forEach((issueId) => {
		const targetIssueId = toIssueId(issueId);
		const issueDependencies = dependenciesHash[targetIssueId];

		if (itemsHash[targetIssueId] && positionsHash[targetIssueId] !== undefined) {
			const targetItem = itemsHash[targetIssueId];
			const targetDate = evaluateTargetDependencyDate(targetItem);

			if (targetDate !== undefined) {
				const to = {
					id: toIssueId(targetIssueId),
					startDate: targetDate,
					y: positionsHash[targetIssueId],
					color: targetItem.color,
				};
				issueDependencies.forEach((sourceIssueId) => {
					if (itemsHash[sourceIssueId] && positionsHash[sourceIssueId] !== undefined) {
						const sourceItem = itemsHash[sourceIssueId];
						const sourceDate = evaluateSourceDependencyDate(sourceItem);

						if (sourceDate !== undefined) {
							const itemHeight = DEFAULT_ITEM_HEIGHT;
							dependencies.push({
								itemHeight,
								from: {
									id: sourceIssueId,
									dueDate: sourceDate,
									y: positionsHash[sourceIssueId],
									color: sourceItem.color,
								},
								to,
								isOverlapping: isDependencyDatesOverlapping(
									startDateHash[sourceIssueId],
									dueDateHash[sourceIssueId],
									startDateHash[issueId],
									dueDateHash[issueId],
								),
							});
						}
					}
				});
			}
		}
	});

	return dependencies;
};
